module.exports = __webpack_public_path__ + "static/media/covid_qr_export_2.cd9f5cfa.png";